module.exports = __webpack_public_path__ + "img/max_deposit_ntd_mobile3.6453d9d0.png";